import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import jwt_decode from 'jwt-decode';
import { loginSuccess, resetAuth } from 'libs/shared/data/stores/auth/auth.actions';
import { getAuthUser } from 'libs/shared/data/stores/auth/auth.selectors';

import { LoginResponse } from '@offconon/core-api';
import {
  LayoutService,
  setLeftColumnVisible,
  setRightColumnVisible,
} from '@offconon/shared/features/layout';
import { resetSelectedBusiness } from '@offconon/workroom/store/business';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private router = inject(Router);

  private store = inject(Store);
  currentUserValue: any;
  currentUserSubject = this.store.select(getAuthUser);
  private layoutService = inject(LayoutService);

  constructor() {
    this.currentUserSubject.subscribe((user) => {
      this.currentUserValue = user;
    });
  }

  login(user: LoginResponse) {
    this.currentUserValue = user;
    this.store.dispatch(loginSuccess({ loginResponse: user, returnUrl: '/' }));
  }

  isLoggedIn() {
    if (!this.currentUserValue) {
      this.resetLayout();

      return false;
    }
    const decoded: any = jwt_decode(this.currentUserValue.jwt_token);
    const now = new Date();
    const exp = new Date(decoded.exp * 1000);
    if (exp < now) {
      return false;
    }
    return true;
  }
  logout() {
    this.store.dispatch(resetAuth());
    this.store.dispatch(resetSelectedBusiness());
    this.resetLayout();

    this.currentUserValue = null;
    this.router.navigate(['/']);
  }

  resetLayout() {
    this.layoutService.resetContainer('leftBottom');
    this.layoutService.resetContainer('rightBottom');
    this.layoutService.resetContainer('leftTop');
    this.layoutService.resetContainer('contentHeader');
    this.store.dispatch(setLeftColumnVisible({ leftColumnVisible: false }));
    this.store.dispatch(setRightColumnVisible({ rightColumnVisible: false }));
  }
}
